// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2qZoe","checkboxCol":"Table_checkboxCol__KyU-e","emailCol":"Table_emailCol__2VeEN","actionCol":"Table_actionCol__1O5jT"};